import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReturn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.60449 6.53906L4.75054 10.1021L8.31356 8.95604",
		stroke: "#2B313A",
		strokeWidth: 1.2476,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.91202 9.52647C7.00399 7.21751 9.35463 5.62022 12.0783 5.62022C15.8434 5.62022 18.8957 8.67244 18.8957 12.4376C18.8957 16.2027 15.8434 19.2549 12.0783 19.2549C9.35461 19.2549 7.00396 17.6576 5.912 15.3486L4.28467 15.3486C5.46467 18.5064 8.50893 20.7549 12.0783 20.7549C16.6719 20.7549 20.3957 17.0311 20.3957 12.4376C20.3957 7.84402 16.6719 4.12022 12.0783 4.12022C8.50894 4.12022 5.46469 6.36867 4.28468 9.52648L5.91202 9.52647Z",
		fill: "black"
	})]
});
export default SvgReturn;
